import { createContext, useState, ReactNode } from "react";
import { DashboardLayoutSettings, LayoutSettings } from "../components/dashboard/layout/layout-settings";
import merge from "lodash/merge";

interface SettingsContextProps {
  settings: LayoutSettings;
  updateSettings: (update: Partial<LayoutSettings>) => void;
}

interface SettingsProviderProps {
  settings?: LayoutSettings;
  children: ReactNode;
}

export const SettingsContext = createContext<SettingsContextProps>({
  settings: DashboardLayoutSettings,
  updateSettings: () => { },
});

export default function SettingsProvider({ settings, children }: SettingsProviderProps) {
  const [currentSettings, setCurrentSettings] = useState<LayoutSettings>(settings || DashboardLayoutSettings);

  const handleUpdateSettings = (update: Partial<LayoutSettings>): void => {
    const merged = merge({}, currentSettings, update);
    setCurrentSettings(merged);
  };

  return (
    <SettingsContext.Provider value={{ settings: currentSettings, updateSettings: handleUpdateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}